import { useCallback, useEffect } from "react";
import { fetchPersonsByOrganization } from "src-next/modules/person-batch-register";
import { useAsyncTask } from "src-next/shared/utils/useAsyncTask";

const EMPTY_PERSONS: fhir5.Person[] = [];

/**
 * Persons da organização do CRM (extrato FluxZap).
 * Falha isolada: não derruba Patients nem o histórico.
 */
export function useCommunicationsOrganizationPersons(
  organizationId?: string,
  revision = 0,
) {
  const load = useCallback((id: string) => fetchPersonsByOrganization(id), []);
  const { run, data, status } = useAsyncTask<[string], fhir5.Person[]>({
    task: load,
    initialData: EMPTY_PERSONS,
  });

  useEffect(() => {
    const trimmed = organizationId?.trim();
    if (!trimmed) return;
    void run(trimmed);
  }, [organizationId, revision, run]);

  const refetch = useCallback(() => {
    const trimmed = organizationId?.trim();
    if (trimmed) void run(trimmed);
  }, [organizationId, run]);

  return {
    persons: data ?? EMPTY_PERSONS,
    refetch,
    hasFetchedOnce: status === "success" || status === "error",
  };
}
